<template>
  <div class="excel-export-container">
    <el-page-header content="店面全量数据导出" />
    <el-card class="export-card" shadow="hover">
      <div class="query-section">
        <el-form :inline="true" class="export-query-form">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-download"
              @click="exportStoreAllExcel"
              :loading="isExporting"
            >
              导出店面全量数据（12个Sheet）
            </el-button>
          </el-form-item>
        </el-form>
        <div class="export-tip">
          <i class="el-icon-info"></i>
          温馨提示：全量数据将整合店面业务（6个Sheet）+店面辅助（6个Sheet）共12个工作表数据，导出格式为.xlsx，数据实时从数据库查询，导出过程请耐心等待。<br/>
          <span style="color:#f56c6c;font-size:12px;">若未自动下载，请检查浏览器是否拦截了下载弹窗</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import service from '@/utils/request'

export default {
  name: 'StoreAllDataExport',
  data() {
    return {
      isExporting: false
    }
  },
  methods: {
    async exportStoreAllExcel() {
      this.isExporting = true
      try {
        // 适配12个Sheet的导出接口，保留核心配置
        const response = await service.get(
          'excel/export/store-all', // 12个Sheet的导出接口
          {
            timeout: 900000,        // 15分钟超时（适配更多Sheet的大数据导出）
            responseType: 'blob',   // 强制二进制流接收
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          }
        )

        // 显式指定Blob为Excel类型，避免乱码
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        })

        // 过滤空文件
        if (blob.size < 100) {
          this.$message.error('店面全量数据导出失败：后端返回空文件，无有效数据');
          return;
        }

        // 生成带时间戳的文件名，区分12个Sheet的导出文件
        const now = new Date()
        const timeStr = now.getFullYear() + 
          (now.getMonth() + 1).toString().padStart(2, '0') + 
          now.getDate().toString().padStart(2, '0') + 
          now.getHours().toString().padStart(2, '0') + 
          now.getMinutes().toString().padStart(2, '0') + 
          now.getSeconds().toString().padStart(2, '0')
        const fileName = `店面全量数据_12个Sheet_${timeStr}.xlsx`

        // 双兜底下载逻辑（a标签+window.open）
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = fileName
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }))
        // 延迟清理资源
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)

        // 兜底方案
        setTimeout(() => {
          if (document.querySelector(`a[href="${downloadUrl}"]`) === null) {
            window.open(downloadUrl, '_blank')
          }
        }, 1000)

        this.$message.success('店面全量数据（12个Sheet）导出成功！若未自动下载，请检查浏览器下载弹窗拦截～')

      } catch (error) {
        // 精准错误提示，和模板保持一致
        console.error('12个Sheet导出真实错误信息：', error);
        if (error.response) {
          this.$message.error(`店面全量数据导出失败：接口返回${error.response.status}错误（${error.response.statusText}）`);
        } else if (error.request) {
          this.$message.error('店面全量数据导出失败：网络不通，未收到后端响应，请检查网络');
        } else if (error.message.includes('config')) {
          this.$message.error('店面全量数据导出失败：请求配置异常，请检查全局request封装');
        } else {
          this.$message.error(`店面全量数据导出失败：${error.message || '未知错误'}`);
        }
      } finally {
        this.isExporting = false
      }
    }
  }
}
</script>

<style scoped>
.excel-export-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 120px);
}
.export-card {
  padding: 30px;
}
.query-section {
  margin-bottom: 20px;
}
.export-query-form {
  margin-bottom: 15px;
}
.export-tip {
  padding: 10px 15px;
  background-color: #e6f7ff;
  border-radius: 6px;
  color: #1890ff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.6;
}
.export-tip .el-icon-info {
  margin-right: 8px;
  font-size: 16px;
  vertical-align: middle;
}
</style>